import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

// Attach JWT token to every request automatically
API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  const adminToken = localStorage.getItem('admin_token');
  // Admin routes use admin token, client routes use client token
  if (config.url?.includes('/admin')) {
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  } else {
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    const isLoginEndpoint = err.config?.url?.includes('/login');
    if (err.response?.status === 401 && !window.location.pathname.startsWith('/admin') && !isLoginEndpoint) {
      localStorage.removeItem('token');
      localStorage.removeItem('client_code');
      localStorage.removeItem('name');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const login           = (client_code, password) =>
  API.post('/login', { client_code: parseInt(client_code), password });
export const getMe           = ()             => API.get('/me');
export const getSummary      = ()             => API.get('/me/summary');
export const getHoldings     = ()             => API.get('/me/holdings');
export const getTrend        = (filter='ALL') => API.get(`/me/trend?filter=${filter}`);
export const getReturns      = ()             => API.get('/me/returns');
export const changePassword  = (old_password, new_password) =>
  API.post('/me/change-password', { old_password, new_password });
export const loginEmail       = (email, password) =>
  API.post('/login/email', { email, password });
export const loginSelectAccount = (email, password, client_code) =>
  API.post('/login/select-account', { email, password, client_code });
export const forgotPassword   = (email) =>
  API.post('/forgot-password', { email });
export const verifyOTP        = (email, otp, new_password) =>
  API.post('/verify-otp', { email, otp, new_password });

export const switchAccount = (client_code) =>
  API.post('/switch-account', { client_code });